import React from 'react';

import Money from 'components/Money';

import './styles.css';

const RemainingCredit = ({overpayment}) => {
  return (
    <div className="RemainingCredit">
      <div className="section">
        <div className="header">Total credit remaining</div>
        <div className="value">
          <Money amount={overpayment.remainingCredit} />
        </div>
      </div>
    </div>
  );
};

export default RemainingCredit;
